import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "оформление заказа", -1)
const _hoisted_2 = { class: "ordering-sum" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Сумма заказа:", -1)
const _hoisted_4 = { class: "price" }
const _hoisted_5 = { class: "ordering-container" }
const _hoisted_6 = { class: "tab" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "ordering-main" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "client-name" }, [
  /*#__PURE__*/_createTextVNode("Ваше имя"),
  /*#__PURE__*/_createElementVNode("sup", null, "*")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "client-phone" }, [
  /*#__PURE__*/_createTextVNode("Номер телефона"),
  /*#__PURE__*/_createElementVNode("sup", null, "*")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "client-time" }, [
  /*#__PURE__*/_createTextVNode("Время"),
  /*#__PURE__*/_createElementVNode("sup", null, "*")
], -1)
const _hoisted_12 = ["value", "selected"]
const _hoisted_13 = {
  key: 0,
  class: "ordering-delivery"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createTextVNode("Детали доставки"),
  /*#__PURE__*/_createElementVNode("sup", null, "*")
], -1)
const _hoisted_15 = { class: "ordering-delivery-container" }
const _hoisted_16 = ["for"]
const _hoisted_17 = ["id", "onUpdate:modelValue", "placeholder"]
const _hoisted_18 = { class: "ordering-sum" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Стоимость доставки:", -1)
const _hoisted_20 = {
  key: 0,
  class: "price"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "client-comment" }, "Комментарий", -1)
const _hoisted_23 = { class: "ordering-sum total" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Итого:", -1)
const _hoisted_25 = { class: "price" }
const _hoisted_26 = {
  key: 0,
  class: "alert-block fadeIn"
}
const _hoisted_27 = { class: "ordering-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("h3", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.basketCost), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryTypes, (delivery, ind) => {
          return (_openBlock(), _createElementBlock("div", {
            key: ind,
            class: _normalizeClass(["tabclick", { active: _ctx.orderData.deliveryType == ind }]),
            onClick: ($event: any) => (_ctx.changeDeliveryType(ind))
          }, _toDisplayString(delivery.name), 11, _hoisted_7))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "client-name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderData.clientName) = $event)),
            autocomplete: "off",
            required: ""
          }, null, 512), [
            [
              _vModelText,
              _ctx.orderData.clientName,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            id: "client-phone",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderData.clientPhone) = $event)),
            autocomplete: "off",
            maxlength: "14",
            required: ""
          }, null, 512), [
            [
              _vModelText,
              _ctx.orderData.clientPhone,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderData.deliveryTime) = $event)),
            id: "client-time"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deliveryTimes, (timeData, ind) => {
              return (_openBlock(), _createElementBlock("option", {
                value: timeData.time[0].getTime(),
                key: ind,
                selected: ind == 0
              }, _toDisplayString(timeData.template), 9, _hoisted_12))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.orderData.deliveryTime]
          ])
        ])
      ]),
      (_ctx.deliveryTypes[_ctx.orderData.deliveryType].params.clientAddressRequired)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientAddress, (addressPart, ind) => {
                return (_openBlock(), _createElementBlock("div", { key: ind }, [
                  _createElementVNode("label", {
                    for: addressPart.id
                  }, _toDisplayString(addressPart.title), 9, _hoisted_16),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    id: addressPart.id,
                    "onUpdate:modelValue": ($event: any) => ((addressPart.value) = $event),
                    placeholder: addressPart.placeholder
                  }, null, 8, _hoisted_17), [
                    [
                      _vModelText,
                      addressPart.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("h3", _hoisted_18, [
              _hoisted_19,
              (_ctx.deliveryCost(_ctx.orderData.deliveryType))
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.deliveryCost(_ctx.orderData.deliveryType)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_21, "Необходимо указать адрес."))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _hoisted_22,
        _withDirectives(_createElementVNode("textarea", {
          type: "text",
          id: "client-comment",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderData.comment) = $event)),
          required: ""
        }, null, 512), [
          [
            _vModelText,
            _ctx.orderData.comment,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("h3", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.orderCost(_ctx.orderData.deliveryType)), 1)
      ])
    ]),
    (_ctx.alert.isActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.alert.message), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("button", {
        class: "btn-main",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendOrder()))
      }, "Отправить заказ")
    ])
  ]))
}